<div class="btn  btn-sm  btn-primary bi bi-send me-1" (click)="InitTracking()" ></div>
<div class="btn  btn-sm  btn-primary bi bi-file-earmark-pdf-fill me-1" (click)="DownloadFile()" *ngIf=" hasTracking()" title="Label Öffnen"></div>
<div class="btn  btn-sm  btn-primary bi bi-qr-code me-1" (click)="DownloadQrFile()" *ngIf=" !IstVersand && hasTracking()" title="QR Öffnen"></div>
<div class="btn  btn-sm  btn-primary bi bi-envelope-at-fill me-1" (click)="openSendDialog()" *ngIf=" hasTracking() " title="Versenden"></div>
<div class="btn  btn-sm  btn-primary" (click)="ResetTracking()" *ngIf=" hasTracking() " title="Reset">
  <i class="fa-solid fa-rotate-left"></i>
</div>
